import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`
const InnerWrapper = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
`

const FormActions = ({ children }) => (
  <Wrapper>
    <InnerWrapper>
      {children}
    </InnerWrapper>
  </Wrapper>
)

export default FormActions



// WEBPACK FOOTER //
// ./src/components/UI/Form/FormActions.jsx